export default {
    accessibility: {
        aria: {
            close: "Close chat window",
            conversationHistoryLabel: "Conversation History",
            conversationHistoryLive: "polite",
            feedbackOverlay: "REMOVE",
            feedbackOverlayCloseIcon: "Close form",
            inputBox: "Type your question here.",
            minimize: "Minimize",
            personaLabel: "Intelligent Virtual Assistant",
            toolbar: "Toolbar",
            calendarWidgetLabel: "Calendar view date/time picker",
            calendarWidgetPreviousMonthLabel: "Previous Month,",
            calendarWidgetNextMonthLabel: "Next Month,",
        },
        focusable: {
            almeResponseMessage: true,
            notificationMessage: true,
            userInputResponseMessage: true,
        },
        focusParentOnClose: true,
        labelledBy: {
            root: "alme--window--header--banner",
        },
        role: {
            close: "REMOVE",
            feedbackOverlay: "REMOVE",
            minimize: "menuitem",
            rootElement: "dialog",
            toolbar: "menubar",
        },
    },
};



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/settings/accessibility.ts